import React, {ReactNode} from 'react'
import './BCardSubscriptionStatus.scss'

interface FeatureSplashWrapperProps {
  children: ReactNode
}

const FeatureSplashWrapper: React.FC<FeatureSplashWrapperProps> = ({children}) => {
  return <div className='feature-splash'>{children}</div>
}

export default FeatureSplashWrapper
